/* eslint-disable */
// 自身のログイン状態をチェックする
import {
    //AmazonCognitoIdentity,
    CognitoUserPool //,
    //CognitoUser,
    //AuthenticationDetails 
} from 'amazon-cognito-identity-js'

import { signOut } from "aws-amplify/auth";
// ログイン情報を共通ストアへ記録するため
import { ref } from 'vue'

import axios from 'axios'
import { useRouter, useRoute } from 'vue-router'
// 複数ユーザー切替えの対応　アカウントユーザーでないユーザーに切り替えた後のユーザーＩＤをcookieに保持する。
import { useCookies } from 'vue3-cookies'
const { cookies } = useCookies()

const router = useRouter();
const route = useRoute();

const GlobalData = {
    $subject_id:null,   //CognitoのサブジェクトID
    $User_email: null,  // メールアドレス
    user_id: null,      // ユーザID
    user_name:null,     // ユーザー名
    kencd: null,        // 県コード
    city: null,         // 市町村名
    kengen: null,       // 権限
    shakyo_code: null,  // 社協コード
    shokugyo_kbn:null,  // 職業区分（参加条件）
    gakusei_kbn:null,   // 学生区分（参加条件）
    gakunen:null,       // 学年（参加条件）
    provider:'mail', // ログインアカウントのプロバイダー
    $taiken_flow:2, // 体験フロー（申込みの流れ）
    $user_end:0, // ユーザー登録終了日を「設定する」にしていて、その日時を過ぎているかどうか　1なら過ぎている
    $ID_Token: {headers: {"Authorization": ""}},    // 認証用IDトークン格納ヘッダー
    $identities : null, // アイデンティティ（ソーシャルログインの場合はこれが入力される）
    enqete_flg : 3, // アンケート回答済みかどうか（0：未回答、1：回答済み、2：回答の必要なし、3：まだ確認できていない）

    $Region:'ap-northeast-1',
    /* 本番環境用 */
  /*
    $UserPoolId: 'ap-northeast-1_3OHgw3311',//ログインユーザープールID（cognito）
    $ClientId: '3gi6k740mjirrs9asa5qro381e',//ログインクライアントID（cognito）
    $social_ClientId: 'vit7up9ka6gsgfa1q3fn2pkda',//ソーシャルログインクライアントID（cognito）
    $IdentityPoolId: 'ap-northeast-1:7cccd05d-44bd-4c61-9e06-15cc02bc823c',
    $API_URL:'https://www.volukatsu-yell.jp/dev/',//APIのURL・テスト用
   // $API_URL:'https://www.volukatsu-yell.jp/prod/',//APIのURL・本番用
    $Ninsho_mail:'@volukatsu-yell.jp',
    $CSV_bucket:'volukatu-file',//CSVファイル（アンケート・報告書回答）のアップロード先
    $Image_bucket:'volukatu-images',//画像のアップロード先 
    $cognitoDomain:"ap-northeast-13ohgw3311.auth.ap-northeast-1.amazoncognito.com",// ドメイン（Cognito）
    $fileupload_url:"https://iqxmjhvxsobcs27kn4tsu7sxie0kwkbd.lambda-url.ap-northeast-1.on.aws/",
    $LINE_text:"LINE",// ソーシャルログイン時のプロバイダー指定（製品版は大文字のLINE）
    */

    
    /* 本番環境用ここまで */

    /* キテル（開発）環境用 */
    $UserPoolId: 'ap-northeast-1_6hWWd14Fy',//ログインユーザープールID（cognito）
    $ClientId: '4sdlml7a8v25nc1ugjvpckk65q',//ログインクライアントID（cognito）
    $social_ClientId: 'athmhjnaevim1oel849bvg145',//ソーシャルログインクライアントID（cognito）
    $IdentityPoolId: 'ap-northeast-1:d026f009-3ac3-4eef-8b41-4da0d048f8de',
    $API_URL:'https://www.volukatsu-taiken.net/dev/',//APIのURL・テスト用
    $Ninsho_mail:'@kitel.co.jp', 
    $CSV_bucket:'taiken-program',//CSVファイル（アンケート・報告書回答）のアップロード先
    $Image_bucket:'volukatsu-images',//画像アップロード先
    $cognitoDomain:"volukatsu.auth.ap-northeast-1.amazoncognito.com",// ドメイン（Cognito）
    $fileupload_url:"https://bnkvulbfw2vvde7wns7kvpz2uq0byeik.lambda-url.ap-northeast-1.on.aws/",
    $LINE_text:"line", // ソーシャルログイン時のプロバイダー指定（開発用は小文字のline）


    /* キテル（開発）環境用ここまで */

    
    $Address_ken_list:["都道府県",//都道府県名のリスト
        "北海道","青森県","岩手県","宮城県","秋田県","山形県","福島県",
        "茨城県","栃木県","群馬県","埼玉県","千葉県","東京都","神奈川県",
        "新潟県","富山県","石川県","福井県","山梨県","長野県","岐阜県",
        "静岡県","愛知県","三重県","滋賀県","京都府","大阪府","兵庫県",
        "奈良県","和歌山県","鳥取県","島根県","岡山県","広島県","山口県",
        "徳島県","香川県","愛媛県","高知県","福岡県","佐賀県","長崎県",
        "熊本県","大分県","宮崎県","鹿児島県","沖縄県"],

    $Kotsu_list:["",  //交通手段（個人・団体）のリスト（１：自家用車、２：バイク、３：自転車、４：電車／バス、５：徒歩）
                 "自家用車","バイク","自転車","電車／バス","徒歩"],

    $Shokugyo_kbn_list:["",  //職業区分（個人）のリスト（１：学生、２：勤労者、９：その他）
                 "学生","勤労者","","","","","","","その他"],

    $Hoken_plan_list:["",//ボランティア活動保険プラン（個人）のリスト（１：基本、２：天災・地震補償、３：特定感染症重点）
                 "基本","天災・地震補償","特定感染症重点"],

    $Dantai_syurui_list:["",//種類（団体）のリスト（１：社協、２：団体、３：管理団体）
                 "社協","団体","管理団体"],

    $Iraisha_syurui_list:["",//依頼者（ボランティア活動）のリスト（１：個人、２：団体）
                 "個人","団体"],
                      
    $Taisho_list:["",//対象者（ボランティア活動）のリスト（１：身体障碍者、２：知的障碍者、３：精神障碍者、４：高齢、５：徒歩、９：その他）
                    "身体障碍者","知的障碍者","精神障碍者","高齢","児童","","","","その他"],

    // 祝日を取得するAPIを呼び出すためのシークレットキー
    $holiday_key : 'AIzaSyBAyiDQTDocEEfUKIH67I_dKh6LzzOg26k',

    // アンケート未回答時の文言
    $enqete_mikaitou : "体験プログラムの申込みにはアンケートにご回答いただく必要があります。",
    $enqete_link : "アンケートフォームへ移動する",
    
    // 通信エラー時メッセージ
    $axios_error : "通信エラーが発生しました。画面を再読み込みしてください。",

}

// 各コンポーネント内の<script>タグ内でグローバル変数を参照するための関数
const getUser_email = function() {// ログインユーザーのメールアドレス
    return GlobalData.$User_email
};
let cognitoUser = {}

let login_retry = 0

// ログイン状態のチェック
async function login_check (){
        try {
            const res = await axios.post("/dev/auth_me", {}, { withCredentials: true });
            const user = res.data; // ← axiosでは .data から取得
        //    alert("ユーザー情報:"+JSON.stringify(user));
            console.log("ユーザー情報:"+JSON.stringify(user))

            GlobalData.$User_email = user.email
            GlobalData.$profile = JSON.parse(user.attributes)
            const profile = GlobalData.$profile

            // アカウント種別の取得
            let providerName = 'mail'
            // identities（ソーシャルログイン専用項目）があるなら代入
            if(user.identities){
                GlobalData.$identities = user.identities
                console.log(GlobalData.$identities)
                if(GlobalData.$identities != null){
                    let identities = JSON.parse(GlobalData.$identities)
                    console.log("identities_providerName:"+identities[0]["providerName"])
                    providerName = identities[0]["providerName"]
                }
            }
            GlobalData.provider = providerName

            // プロフィール情報が読み取れない場合
            if(profile == null || profile.kengen == null){
                // IDは無いが、メールアドレスが分かる場合はプロバイダーとメールアドレスで検索
                // プロフィール情報は読み取れないが、メールアドレス（Cognitoログイン情報）が読み取れる場合
                if(GlobalData.$User_email != null){
                    
                    console.log("login OK & profile null")
                    read_username_provider(providerName,GlobalData.$User_email)
                    return
                }else{
                    // メールアドレス（Cognitoログイン情報）が読み取れない場合は未ログイン
                    console.log("not login")
                    return
                }

            }

            /*
            if(profile.kengen == "Ippan" || profile.kengen == "ippan"){
                // 一般権限の場合はログイン画面に移動する
                location.href=login_url
            }

            // 管理者の場合
            if(profile.kengen == "Admin" || profile.kengen == "admin" || profile.kengen == "Kanri" || profile.kengen == "kanri" ){
                // 社協が違っていたらログイン画面に移動する
                if(profile.shakyo_code != GlobalData.shakyo){
                    location.href=login_url
                }
            }*/
           if(profile.kengen  == "admin" || profile.kengen  == "kanri" || profile.kengen  == "master" || profile.kengen  == "shakyouser" || profile.kengen  == "shisetsu" ){
                alert("このアカウントでは申込者用画面にログインできません。\n申込者用のアカウントをご利用ください。")    
                logout(profile.shakyo_code)
            }

            // ユーザーIDがある場合はIDを元にユーザー情報を取得
            // 複数ユーザー対応　cookieに切り替えたユーザーIDが設定されている時は、切り替えたユーザー情報をGlobalDataに設定する。            
            // cookieに切り替えたユーザーIDが設定されていない時は、/dev/auth_meで取得したユーザー情報をGlobalDataに設定する。           
            if(profile.user_id != null && cookies.isKey('switch_user') == false) {

                if(profile.user_id) GlobalData.user_id = profile.user_id
                if(profile.kencd) GlobalData.kencd = profile.kencd
                if(profile.city) GlobalData.city = profile.city
                if(profile.shakyo_code) GlobalData.shakyo_code = profile.shakyo_code
                
                GlobalData.kengen = profile.kengen
                read_username(GlobalData.user_id)// ユーザー名を取得する
            } else {
                // cookieに切り替えユーザーが設定されている時は、指定されたユーザー情報をGlobalDataに設定する。
                if(cookies.isKey('switch_user')){
                    switch_user(cookies.get('switch_user'))  // ユーザーの切り替え処理
                }
            }
            
            /*else */

            GlobalData.$subject_id = user.subjectid
            console.log(GlobalData.$subject_id)
            //return user;
        } catch (err) {
        
            if(login_retry == 5){
                console.log("login NO Good"+err);

            }else{
                login_retry++
                setTimeout(function(){login_check()},"1000")
            }
        }
    }


const read_username = function(id) {//IDからユーザー名を取得
     // 学生区分がnullの場合は取得する
     axios.post(GlobalData.$API_URL + "TaikenUser_read",
        {
            taikenuser_id: id
        },
        GlobalData.$ID_Token)//ヘッダーを追加（IDトークンを送信）
        .then(response => {
            //正常な結果が返ってきた場合の処理
            // response.data["status"]・・・status=0の時は正常終了、status=1のときは異常終了（データが取得できなかった等）
            // response.data["message"]・・・API処理結果に付随するメッセージ。主にstatus=1（異常終了）の時に利用する

            if(response.data["status"] == 1){

                console.log("IDによるユーザー名の取得でエラーが発生しました。\n"+response.data["message"])

            }else{
                // ユーザーが削除されていなかったら紐づける
                if(response.data.del_flg == false){
                    GlobalData.user_name = response.data.username

                    // 一般、学生区分、学年を入れ替える
                    GlobalData.gakusei_kbn = response.data.gakusei_kbn    // 学生区分
                    GlobalData.gakunen = response.data.gakunen            // 学年
                    GlobalData.shokugyo_kbn = response.data.shokugyo_kbn  // 一般区分

                    console.log("ユーザー名取得："+GlobalData.user_name)
                        
                    console.log("provider:"+response.data.provider)
                    // ユーザー登録時にアカウント種別が取得できなかったユーザーの場合
                    if(response.data.provider == 'null' || response.data.provider == null){
                        let providerName = ''
                        if(GlobalData.$identities != null){
                            let identities = JSON.parse(GlobalData.$identities)
                            console.log("identities_providerName:"+identities[0]["providerName"])
                            providerName = identities[0]["providerName"]
                        }
                        console.log("providerName:"+providerName)
                        update_provider(providerName,id)
                    }else{
                        
                        cookies.set('last_login', response.data.provider, Infinity);  // 登録したユーザーのプロバイダー（ログイン方法）を記録
                    }
                }else{
                    // ユーザーが削除されていたら全てnullに戻す
                    GlobalData.user_name = null
                    GlobalData.user_id = null
                    GlobalData.kencd = null
                    GlobalData.city = null
                    GlobalData.kengen = null
                    GlobalData.shakyo_code = null
                    console.log("ユーザー削除済み")
                    // Cognitoのprofileを更新
                    set_habitat(null,null,null,null,null)
                    location.reload()
                    
                }

                // ログイン情報にプロファイルが存在しない場合
                // Cognitoのprofileを更新
            //    set_habitat(response.data.taikenuser_id,response.data.address_kencd,response.data.address_shi,'ippan',response.data.shakyo_code)
            }
        })
        .catch(error => { 
            console.log("ユーザー名の取得でエラーが発生しました。\n"+error)
        })      
}

let user_update_error = 0
const update_provider = function(provider,id){
    
  // APIへ値を送信する
  axios.post(GlobalData.$API_URL + "TaikenUser_update",
    {taikenuser_id:id, provider:provider})
    .then(response => {
        //正常な結果が返ってきた場合の処理
        // response.data["status"]・・・status=0の時は正常終了、status=1のときは異常終了（データが削除できなかった等）。
        // response.data["message"]・・・API処理結果に付随するメッセージ。主にstatus=1（異常終了）の時に利用する

        if(response.data["status"] == 1){

           console.log("エラーが発生しました。\n"+response.data["message"])
        }else{
           
            cookies.set('last_login', provider, Infinity);  // 登録したユーザーのプロバイダー（ログイン方法）を記録
           console.log("更新完了")
        }
    })
    .catch(error => {
        
        if(user_update_error == 6){
            console.log(error + GlobalData.$axios_error);
        }else{
            user_update_error++
            setTimeout(function(){update_provider(provider,id)},"1000")
        }
	})
}


const read_username_provider = function(provider,email) {//プロバイダーとメールアドレスからユーザー名を取得
     // 学生区分がnullの場合は取得する
     axios.post(GlobalData.$API_URL + "TaikenUser_read",
        {
            provider: provider,
            email:email
        },
        GlobalData.$ID_Token)//ヘッダーを追加（IDトークンを送信）
        .then(response => {
            //正常な結果が返ってきた場合の処理
            // response.data["status"]・・・status=0の時は正常終了、status=1のときは異常終了（データが取得できなかった等）
            // response.data["message"]・・・API処理結果に付随するメッセージ。主にstatus=1（異常終了）の時に利用する
            if(response.data["status"] == 1){
                console.log("プロバイダーによるユーザー名の取得でエラーが発生しました。\n"+response.data["message"])
                // ない場合は登録画面へ
                console.log(location.pathname.split("/") )

                // location_list = ["","（社協コード）","Taiken","（これ以降はページに応じて入っていく。無い場合もある）"]
                let location_list = location.pathname.split("/")

                if(location_list[3]){
                    if(location_list[3] != "user_toroku" && location_list[3] != "Policy" && location_list[3] != "mypage"){
                        // 3番目がuser_toroku（＝プロフィール情報入力画面）、Policy（＝社協のプライバシーポリシー）、mypage以外の場合は登録画面に移動
                        location.href = "/"+location_list[1]+"/Taiken/user_toroku"
                    }
                }else{
                    // 3番目がない（＝HOME）の場合は登録画面に移動
                    location.href = "/"+location_list[1]+"/Taiken/user_toroku"
                }
                /*
                if(route.params.cmd != "user_toroku"){
                    location.href = "/"+route.params.shakyo+"/Taiken/user_toroku"
                }*/
            }else{
                GlobalData.user_name = response.data.username
                GlobalData.user_id = response.data.taikenuser_id
                GlobalData.kencd = response.data.address_kencd
                GlobalData.city = response.data.address_shi
                GlobalData.kengen = 'ippan'
                GlobalData.shakyo_code = response.data.choson_code
                console.log("プロバイダー・メールアドレス取得："+JSON.stringify(GlobalData.user_name))
                // Cognitoのprofileを更新
                set_habitat(response.data.taikenuser_id,response.data.address_kencd,response.data.address_shi,'ippan',response.data.choson_code)
            }
        })
        .catch(error => { 
            console.log("ユーザー名の取得でエラーが発生しました。\n"+error)
        })      
}


//---------------- ログアウト
async function handleSignOut(cityname) {

    GlobalData.$User_email = null
    GlobalData.user_id = null
    GlobalData.kencd = null
    GlobalData.city = null
    GlobalData.kengen = null
    
    GlobalData.shakyo_code = null

    try {
      await signOut();


    } catch (error) {
     // console.log('error signing out: ', error);
    } finally {
        // ログアウト時は、cookieの情報をクリアする。
        if(cookies.isKey('switch_user')){
            cookies.remove('switch_user')
        }
        if(cookies.isKey('family')){
            cookies.remove('family')
        }
    }
    
    location.href = location.protocol+'//'+location.host+"/"+cityname+'/Taiken'
  }
  
  //—- ログアウト —------------------------------------------
  const logout = async (cityname,type) => {
      
      try {
            await axios.post("/dev/logout_lambda", {}, { withCredentials: true });
            //alert("ログアウトしました。");
            GlobalData.$User_email = null
            GlobalData.user_id = null
            GlobalData.kencd = null
            GlobalData.city = null
            GlobalData.kengen = null
            GlobalData.shakyo_code = null

            sessionStorage.removeItem('return_shakyo')
    
      } catch (err) {
          console.error(err);
        //  alert("ログアウト失敗");
      } finally {
        // ログアウト時は、cookieの情報をクリアする。
        if(cookies.isKey('switch_user')){
            cookies.remove('switch_user')
        }
        if(cookies.isKey('family')){
            cookies.remove('family')
        }
      }

      if(type != undefined){

        if(type == "move_login" || type == "move_add"){
            if(cookies.isKey('provider')){
                cookies.remove('provider')
            }
            if(cookies.isKey('social_login')){
                cookies.remove('social_login')
            }
            if(type == "move_add"){
//                location.href = location.protocol+'//'+location.host+"/"+cityname+'/Taiken/user_signin'

                // 一覧に戻すように修正
                location.href = location.protocol+'//'+location.host+"/"+cityname+'/Taiken'

            }else if(type == "move_login"){
                location.href = location.protocol+'//'+location.host+"/"+cityname+'/Taiken/login'
            }
            
        }else{
            location.href = location.protocol+'//'+location.host+"/"+cityname+'/Taiken'
        }

      }else{
        location.href = location.protocol+'//'+location.host+"/"+cityname+'/Taiken'
      }
  };

/*
const logout = function(cityname) {

    
    var poolData = {
            UserPoolId : GlobalData.$UserPoolId,
            ClientId : GlobalData.$ClientId
    };
    var userPool = new CognitoUserPool(poolData);
    var cognitoUser = userPool.getCurrentUser();
    if (cognitoUser) {
        // ログアウト
        cognitoUser.signOut();
        GlobalData.$User_email = "";
        //alert("ログアウトしました。");
    }

    GlobalData.$User_email = null
    GlobalData.user_id = null
    GlobalData.kencd = null
    GlobalData.city = null
    GlobalData.kengen = null
    GlobalData.shakyo_code = null

    sessionStorage.removeItem('return_shakyo')
    location.href = location.protocol+'//'+location.host+"/"+cityname+'/Taiken'
}

*/

// cookieに指定されたユーザーIDよりユーザー情報を取得しGlobalDataに設定する。
const switch_user = function(user_id) {

// user_idよりテーブルにあるユーザー情報を取得する
    axios.post(GlobalData.$API_URL + "TaikenUser_read",
    {
        taikenuser_id: user_id
    },
    GlobalData.$ID_Token)//ヘッダーを追加（IDトークンを送信）
    .then(res => {
        //正常な結果が返ってきた場合の処理
        // GlobalDataを取得してきたユーザー情報から塗変える
        if(res.data["status"] == 1){

            console.log("IDによるユーザー情報の取得でエラーが発生しました。\n"+res.data["message"])
        }else{

            // GlobalDataを取得してきたユーザー情報から塗変える
            GlobalData.$User_email  = res.data.email         // メールアドレス
            GlobalData.user_id      = res.data.taikenuser_id // ユーザID
            GlobalData.user_name    = res.data.username      // ユーザー名
            GlobalData.kencd        = res.data.address_kencd // 県コード
            GlobalData.city         = res.data.address_shi   // 市町村名
            GlobalData.kengen       = "ippan"                // 権限
            GlobalData.shakyo_code  = res.data.choson_code   // 社協コード
            GlobalData.gakusei_kbn = res.data.gakusei_kbn    // 学生区分
            GlobalData.gakunen = res.data.gakunen            // 学年
            GlobalData.shokugyo_kbn = res.data.shokugyo_kbn  // 一般区分

            console.log("ユーザー切替  ユーザー名："+GlobalData.user_name+" 学生区分："+GlobalData.gakusei_kbn+"/学年"+GlobalData.gakunen)
            console.log("provider:"+res.data.provider)
            // ユーザー登録時にアカウント種別が取得できなかったユーザーの場合
            if(res.data.provider == 'null' || res.data.provider == null){
                let providerName = ''
                if(GlobalData.$identities != null){
                    let identities = JSON.parse(GlobalData.$identities)
                    console.log("identities_providerName:"+identities[0]["providerName"])
                    providerName = identities[0]["providerName"]
                }
                console.log("providerName:"+providerName)
                update_provider(providerName,res.data.taikenuser_id )
            }else{
                
                cookies.set('last_login', res.data.provider, Infinity);  // 登録したユーザーのプロバイダー（ログイン方法）を記録
            }

        }
    })
    .catch(error => { 
        // alert("複数ログインのユーザー情報の取得でエラーが発生しました。\n"+error)
    })      

}

// 曜日配列
const youbi_list = ["日","月","火","水","木","金","土"]
   //年月日の表示を整える
   let DateSetting = function(changedate){

    if(changedate != null){
        

        let date = Date.parse(changedate);
        let set_date = new Date(date);
        set_date = set_date.toLocaleString("ja-JP", { timeZone: "Europe/London" });
        set_date = new Date(set_date);

        return (set_date.getMonth()+1)+"月"+set_date.getDate()+"日("+youbi_list[set_date.getDay()]+")";
    }else{
        return
    }
 }
 
   //年月日＋時間の表示を整える(EU時間)
   let EuDateSetting = function(changedate){
      /*
      let date = Date.parse(changedate);
      let set_date = new Date(date);
      set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
      set_date = new Date(set_date);
      set_date.setHours(set_date.getHours()-8);
  */
      let eudate = Date.parse(changedate);
      let eu_set_date = new Date(eudate);
      eu_set_date = eu_set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
      eu_set_date = new Date(eu_set_date);
      eu_set_date.setHours(eu_set_date.getHours()-9);
  
      const set_month = eu_set_date.getMonth()+1
  
      // 日時から日と時をそれぞれ抜き出す
      let day = (eu_set_date.getFullYear())+"-"+('00'+set_month).slice(-2)+"-"+('00'+eu_set_date.getDate()).slice(-2)
      let time = ('00'+eu_set_date.getHours()).slice(-2)+":"+('00'+eu_set_date.getMinutes()).slice(-2);
  
      let return_date = new Date(day + " "+time)
      return_date = return_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
      return_date = new Date(return_date);
  
      return (return_date.getMonth()+1)+"月"+return_date.getDate()+"日("+youbi_list[return_date.getDay()]+")"
   }
 //時間の表示を整える
 let TimeSetting = function(changetime){
  if(changetime != null){
      
      return changetime.slice( 0, 5 );
  }else{
      return ""
  }

 }
 //年月日＋時間の表示を整える
 let DateTimeSetting = function(changedate){
    let date = Date.parse(changedate);
    let set_date = new Date(date);
    set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
    set_date = new Date(set_date);
    set_date.setHours(set_date.getHours());

    //return date;
    return (set_date.getMonth()+1)+"月"+set_date.getDate()+"日("+youbi_list[set_date.getDay()]+") "+ ('00'+set_date.getHours()).slice(-2)+":"+('00'+set_date.getMinutes()).slice(-2)
 }

 //年月日＋時間の表示を整える(EU時間)
 let EuDateTimeSetting = function(changedate){
    /*
    let date = Date.parse(changedate);
    let set_date = new Date(date);
    set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
    set_date = new Date(set_date);
    set_date.setHours(set_date.getHours()-8);
*/

    let eudate = Date.parse(changedate);
    let eu_set_date = new Date(eudate);
    eu_set_date = eu_set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
    eu_set_date = new Date(eu_set_date);
    eu_set_date.setHours(eu_set_date.getHours()-9);

    const set_month = eu_set_date.getMonth()+1

    // 日時から日と時をそれぞれ抜き出す
    let day = (eu_set_date.getFullYear())+"-"+('00'+set_month).slice(-2)+"-"+('00'+eu_set_date.getDate()).slice(-2)
    let time = ('00'+eu_set_date.getHours()).slice(-2)+":"+('00'+eu_set_date.getMinutes()).slice(-2);

    let return_date = new Date(day + " "+time)
    return_date = return_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
    return_date = new Date(return_date);
    return (return_date.getMonth()+1)+"月"+return_date.getDate()+"日("+youbi_list[return_date.getDay()]+") "+ ('00'+return_date.getHours()).slice(-2)+":"+('00'+return_date.getMinutes()).slice(-2)
 }

 //〆切日を整える
 let ShimekiriSetting = function(changedate){
    let date = Date.parse(changedate);
    let set_date = new Date(date);
    set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
    set_date = new Date(set_date);
    set_date.setHours(set_date.getHours());

    //return date;
    return set_date
 }

 //〆切日を整える(EU時間)
 let EuShimekiriSetting = function(changedate){

    let eudate = Date.parse(changedate);
    let eu_set_date = new Date(eudate);
    eu_set_date = eu_set_date.toLocaleString("ja-JP", { timeZone: "Europe/London" });
    eu_set_date = new Date(eu_set_date);
    eu_set_date.setHours(eu_set_date.getHours());
    
    const set_month = eu_set_date.getMonth()+1
    
    // 日時から日と時をそれぞれ抜き出す
    let day = (eu_set_date.getFullYear())+"-"+('00'+set_month).slice(-2)+"-"+('00'+eu_set_date.getDate()).slice(-2)
    let time = ('00'+eu_set_date.getHours()).slice(-2)+":"+('00'+eu_set_date.getMinutes()).slice(-2);

    let return_date = new Date(day + " "+time)
    return_date = return_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
    return_date = new Date(return_date);

    return return_date
    /*
    
    let date = Date.parse(changedate);
    let set_date = new Date(date);
    set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
    set_date = new Date(set_date);
    set_date.setHours(set_date.getHours()-8);
    */

    //return set_date;
 }
 

 //公開日を整える
 let Kokai_setting = function(set_date,set_hour){
    
    
    let kokai_date = new Date(set_date + " "+set_hour)
    kokai_date = kokai_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
    kokai_date = new Date(kokai_date);
    return kokai_date
 }

 // 開催日を整える
let Kaisai_setting = function(chengedate){

    let kaisai_date = Date.parse(chengedate);
    let set_kaisai_date = new Date(kaisai_date);
    set_kaisai_date = set_kaisai_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
    set_kaisai_date = new Date(set_kaisai_date);
    console.log("set_kaisai_date:"+set_kaisai_date)
    return set_kaisai_date.getFullYear()+"-"+(set_kaisai_date.getMonth()+1)+"-"+set_kaisai_date.getDate()

}

const Search_timestamp = function(timestamp){// 各検索の「更新日時」の計算
    let date = Date.parse(timestamp);
    let set_date = new Date(date);
    set_date = set_date.toLocaleString("ja-JP", { timeZone: "Europe/London" });
    set_date = new Date(set_date);
    set_date.setHours(set_date.getHours());
    //return date;
    return set_date.getFullYear()+"-"+('00'+(set_date.getMonth()+1)).slice(-2)+"-"+('00'+set_date.getDate()).slice(-2)+" "+('00'+set_date.getHours()).slice(-2)+":"+('00'+set_date.getMinutes()).slice(-2);
}


  let youbi_irekae = function(set_youbi){
    
    if(set_youbi != null){
        
        // 表示したい並び順
        const order = ["月", "火", "水", "木", "金", "土", "日", "祝"];

        // 上の並び順に合わせて、「、」区切りで並び替える
        const after = set_youbi
        .split("、")
        .sort((a, b) => order.indexOf(a) - order.indexOf(b))
        .join("、");

        console.log(set_youbi+"→"+after)
        
        return after
        /*
        set_youbi = set_youbi.replace(/､/g, '、')
        
        let set_array = set_youbi.split("、")

        const syuku_youbi_list = ["日","月","火","水","木","金","土","祝"]
        let disp_youbi_list = []

        let set_list = ""
        // 日・祝以外を取得
        for(let s = 0;s<set_array.length;s++){
            for(let l = 0;l<syuku_youbi_list.length;l++){
                if(set_array[s] == syuku_youbi_list[l]){
                    if(syuku_youbi_list[l] != "日" && syuku_youbi_list[l] != "祝" ){
                        disp_youbi_list[disp_youbi_list.length] = syuku_youbi_list[l]
                    }
                }
            }
        }
        // 日を取得
        for(let s = 0;s<set_array.length;s++){
            for(let l = 0;l<syuku_youbi_list.length;l++){
                if(set_array[s] == syuku_youbi_list[l]){
                    if(syuku_youbi_list[l] == "日" ){
                        disp_youbi_list[disp_youbi_list.length] = syuku_youbi_list[l]
                    }
                }
            }
        }
        // 祝を取得
        for(let s = 0;s<set_array.length;s++){
            for(let l = 0;l<syuku_youbi_list.length;l++){
                if(set_array[s] == syuku_youbi_list[l] || set_array[s] == "祝日"){
                    if( syuku_youbi_list[l] == "祝" ){
                        disp_youbi_list[disp_youbi_list.length] = syuku_youbi_list[l]
                    }
                }
            }
        }

        // 重複を削除
        disp_youbi_list = Array.from(new Set(disp_youbi_list));
        for(let d = 0;d<disp_youbi_list.length;d++){
            
            if(set_list != "") set_list += "、"
            set_list += disp_youbi_list[d]
        }
        return set_list
            */

    }
  }

// 一般ユーザーの追加
let error_count = 0;
async function set_habitat(user_id,kencd,city,kengen,shakyo_code) {
    
    const profile = '{"user_id":'+user_id+',"kencd":'+kencd+',"city":"'+city+'","kengen":"'+kengen+'","shakyo_code":"'+shakyo_code+'"}';
    try {
        const res = await axios.post("/dev/set_habitat", {profile}, { withCredentials: true });
        console.log("ユーザー情報とログイン情報の結びつけ完了︓"+JSON.stringify(res.data));
    } catch (err) {
        console.error(err);
        
        if(error_count == 6){
            alert("ユーザー情報とログイン情報の結びつけに失敗しました。恐れ入りますがシステム管理者にお問い合わせください。"+err);
        }else{
            error_count++
            set_habitat(user_id,kencd,city,kengen,shakyo_code)
        }
    }
}

export { GlobalData, getUser_email, login_check, logout,handleSignOut, Search_timestamp, set_habitat,DateSetting,EuDateSetting,TimeSetting,DateTimeSetting,ShimekiriSetting,EuDateTimeSetting,EuShimekiriSetting,Kokai_setting,Kaisai_setting,youbi_irekae }
